export const ChatContextMenuSeparator = () => (
  <div
    data-testid="chat-context-menu-separator"
    className="h-px w-full bg-border-subtle"
  />
);
